// Drama Configuration for A/B Testing
// Structure: testId -> language -> dramas array

export const testConfig = {
  '20260108': {
    en: [
      {
        id: 'zombie_en_zhenren',
        title: '',
        description: '',
        coverImage: '',
        episodes: [
          {
            episodeNumber: 1,
            videoUrl: 'https://static.telereels.com/showtest/zombie/zombie_ep1_zhenren_en.mp4',
            title: ''
          },
          {
            episodeNumber: 2,
            videoUrl: 'https://static.telereels.com/showtest/zombie/zombie_ep2_zhenren_en.mp4',
            title: ''
          }
        ],
        videoUrl: 'https://static.telereels.com/showtest/zombie/zombie_ep1_zhenren_en.mp4',
      },
      {
        id: 'prisoner_en',
        title: '',
        description: '',
        coverImage: '',
        episodes: [
          {
            episodeNumber: 1,
            videoUrl: 'https://static.telereels.com/showtest/prisoner_en.mp4',
            title: ''
          }
        ],
        videoUrl: 'https://static.telereels.com/showtest/prisoner_en.mp4',
      },
      {
        id: 'reborn_en',
        title: '',
        description: '',
        coverImage: '',
        episodes: [
          {
            episodeNumber: 1,
            videoUrl: 'https://static.telereels.com/showtest/reborn_en.mp4',
            title: ''
          }
        ],
        videoUrl: 'https://static.telereels.com/showtest/reborn_en.mp4',
      }
    ],
    es: [
      {
        id: 'zombie_es_zhenren',
        title: '',
        description: '',
        coverImage: '',
        episodes: [
          {
            episodeNumber: 1,
            videoUrl: 'https://static.telereels.com/showtest/zombie/zombie_ep1_zhenren_es.mp4',
            title: ''
          },
          {
            episodeNumber: 2,
            videoUrl: 'https://static.telereels.com/showtest/zombie/zombie_ep2_zhenren_es.mp4',
            title: ''
          }
        ],
        videoUrl: 'https://static.telereels.com/showtest/zombie/zombie_ep1_zhenren_es.mp4',
      },
      {
        id: 'prisoner_es',
        title: '',
        description: '',
        coverImage: '',
        episodes: [
          {
            episodeNumber: 1,
            videoUrl: 'https://static.telereels.com/showtest/prisoner_es.mp4',
            title: ''
          }
        ],
        videoUrl: 'https://static.telereels.com/showtest/prisoner_es.mp4',
      },
      {
        id: 'reborn_es',
        title: '',
        description: '',
        coverImage: '',
        episodes: [
          {
            episodeNumber: 1,
            videoUrl: 'https://static.telereels.com/showtest/reborn_es.mp4',
            title: ''
          }
        ],
        videoUrl: 'https://static.telereels.com/showtest/reborn_es.mp4',
      }
    ],
    pt: [
      {
        id: 'zombie_pt_zhenren',
        title: '',
        description: '',
        coverImage: '',
        episodes: [
          {
            episodeNumber: 1,
            videoUrl: 'https://static.telereels.com/showtest/zombie/zombie_ep1_zhenren_pt.mp4',
            title: ''
          },
          {
            episodeNumber: 2,
            videoUrl: 'https://static.telereels.com/showtest/zombie/zombie_ep2_zhenren_pt.mp4',
            title: ''
          }
        ],
        videoUrl: 'https://static.telereels.com/showtest/zombie/zombie_ep1_zhenren_pt.mp4',
      },
      {
        id: 'prisoner_pt',
        title: '',
        description: '',
        coverImage: '',
        episodes: [
          {
            episodeNumber: 1,
            videoUrl: 'https://static.telereels.com/showtest/prisoner_pt.mp4',
            title: ''
          }
        ],
        videoUrl: 'https://static.telereels.com/showtest/prisoner_pt.mp4',
      },
      {
        id: 'reborn_pt',
        title: '',
        description: '',
        coverImage: '',
        episodes: [
          {
            episodeNumber: 1,
            videoUrl: 'https://static.telereels.com/showtest/reborn_pt.mp4',
            title: ''
          }
        ],
        videoUrl: 'https://static.telereels.com/showtest/reborn_pt.mp4',
      }
    ]
  },
};


export const supportedLanguages = ['en', 'es', 'pt'];
export const defaultLanguage = 'en';
export const defaultTestId = '20260108';

/**
 * Get dramas for a specific test and language
 * @param {string} testId - Test identifier
 * @param {string} language - Language code (en, es, pt)
 * @returns {Array} Array of drama objects for the test and language
 */
export const getDramasByTest = (testId, language) => {
  if (!testConfig[testId]) {
    console.warn(`Test ID "${testId}" not found, using default test "${defaultTestId}"`);
    return testConfig[defaultTestId]?.[language] || testConfig[defaultTestId]?.[defaultLanguage] || [];
  }

  const testGroup = testConfig[testId];
  if (!testGroup[language]) {
    console.warn(`Language "${language}" not found for test "${testId}", using default language "${defaultLanguage}"`);
    return testGroup[defaultLanguage] || [];
  }

  return testGroup[language];
};

/**
 * Get all test IDs
 * @returns {Array} Array of test IDs
 */
export const getAllTestIds = () => {
  return Object.keys(testConfig);
};

/**
 * Check if a test ID exists
 * @param {string} testId - Test identifier
 * @returns {boolean} True if test exists
 */
export const testExists = (testId) => {
  return testId in testConfig;
};

/**
 * Detect user's browser language
 * @returns {string} Language code (en, es, pt)
 */
export const detectLanguage = () => {
  const browserLang = navigator.language || navigator.userLanguage;
  const langCode = browserLang.toLowerCase();

  // Check for exact match
  if (supportedLanguages.includes(langCode)) {
    return langCode;
  }

  // Check for partial match (e.g., 'pt-BR' -> 'pt', 'es-ES' -> 'es')
  if (langCode.startsWith('pt')) {
    return 'pt';
  }
  if (langCode.startsWith('es')) {
    return 'es';
  }
  if (langCode.startsWith('en')) {
    return 'en';
  }

  return defaultLanguage;
};

/**
 * Randomly select one drama from the list (A/B Testing)
 * @param {Array} dramas - Array of drama objects
 * @returns {Object} Selected drama
 */
export const selectRandomDrama = (dramas) => {
  if (!dramas || dramas.length === 0) {
    console.error('No dramas available to select');
    return null;
  }
  const randomIndex = Math.floor(Math.random() * dramas.length);
  return dramas[randomIndex];
};

